import React, { useContext, useEffect, useState } from "react";
import { Card, Label, ModalBody, Badge } from "reactstrap";
import {
    Button,
    Block,
    BlockBetween,
    BlockDes,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    Icon,
    Col,
    Row,
    OverlineTitle,
    Sidebar,
    UserAvatar,
} from "../../../components/Component";
import { useHistory } from "react-router";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { urlTenantID, currentTime, findUpper, formDataUsername, monthNames, timeStamp, todaysDate, usaNumRegex, usaNumRegex2, usaNumRegex3 } from "../../../utils/Utils";
import { UserContext } from "../user-manage/UserContext";
import { notes } from "../user-manage/UserData";
import { Link } from "react-router-dom";
import { useLocation } from 'react-router-dom'
import TenantTab from "./TenantTab";
import TenantHeading from "./TenantHeading";
import Api from "../../../Api";
import Swal from "sweetalert2";
import InputMask from "react-input-mask";
import { cloneDeep } from "lodash";

const SMSsetting = ({ match }) => {
    const { contextData } = useContext(UserContext);
    const [data] = contextData;
    const location = useLocation()
    const [sideBar, setSidebar] = useState(false);
    const [user, setUser] = useState();
    const [noteData, setNoteData] = useState(notes);
    const [addNoteModal, setAddNoteModal] = useState(false);
    const [addNoteText, setAddNoteText] = useState("");
    const history = useHistory();

    const [getTenantId, setGetTenantId] = useState(urlTenantID());
    const [val, setVal] = useState({
        TEXT_REMINDER_TYPE: "Twilio",
        TWILIO_ACCOUNT_SID: "",
        TWILIO_ACCOUNT_AUTHTOKEN: "",
        TWILIO_SMS_FROM_NUMBER: "",
        TEXT_REMINDER: true,
        TWILIO_SMS_SERVICE_SID: "",
        TWILIO_SERVICE_SID: "",
        TWILIO_CONVERSATION_SERVICE_SID: "",
    });
    const [prefer, setPrefer] = useState({
        TEXT_REMINDER_TYPE: "",
        TWILIO_ACCOUNT_SID: "",
        TWILIO_ACCOUNT_AUTHTOKEN: "",
        TWILIO_SMS_FROM_NUMBER: "",
        TEXT_REMINDER: "",
        TWILIO_SMS_SERVICE_SID: "",
        TWILIO_SERVICE_SID: "",
        TWILIO_CONVERSATION_SERVICE_SID: "",
    });

    const [regex, setRegex] = useState({
        // TWILIO_SMS_FROM_NUMBER: /^\+\d{1,3}\d{9,10}$/,
        TWILIO_SMS_FROM_NUMBER: /^\+\d{11}$|^\+\d{12}$/,
    })

    const [error, setError] = useState({
        TWILIO_ACCOUNT_SID: "",
        TWILIO_ACCOUNT_AUTHTOKEN: "",
        TWILIO_SMS_FROM_NUMBER: "",
        TWILIO_SMS_SERVICE_SID: "",
        TWILIO_SERVICE_SID: "",
        TWILIO_CONVERSATION_SERVICE_SID: "",
    });

    // grabs the id of the url and loads the corresponding data
    useEffect(() => {
        const id = match.params.id;
        if (id !== undefined || null || "") {
            let spUser = data.find((item) => item.id === Number(id));
            setUser(spUser);
        } else {
            setUser(data[0]);
        }
    }, [match.params.id, data]);

    useEffect(() => {
        getSmsSettings();
    }, [])

    // function to toggle sidebar
    const toggle = () => {
        setSidebar(!sideBar);
    };

    const getSmsSettings = async () => {
        let data = JSON?.stringify([
            { tenantId: getTenantId, keyStr: "TEXT_REMINDER_TYPE", },
            { tenantId: getTenantId, keyStr: "TWILIO_ACCOUNT_SID", },
            { tenantId: getTenantId, keyStr: "TWILIO_ACCOUNT_AUTHTOKEN", },
            { tenantId: getTenantId, keyStr: "TWILIO_SMS_FROM_NUMBER", },
            { tenantId: getTenantId, keyStr: "TEXT_REMINDER" },
            { tenantId: getTenantId, keyStr: "TWILIO_SMS_SERVICE_SID" },
            { tenantId: getTenantId, keyStr: "TWILIO_SERVICE_SID" },
            { tenantId: getTenantId, keyStr: "TWILIO_CONVERSATION_SERVICE_SID" },
        ]);
        let response = await Api?.getSmtpSettings(data);
        let res = response?.data?.data;
        if (res !== null) {
            let datas = {};
            let prefers = {};
            res.forEach(curr => {
                datas[curr.keyStr] = curr.valueStr || "";
                prefers[curr.keyStr] = curr.tenantPrefId;
                if (curr.keyStr === "TEXT_REMINDER") {
                    datas[curr.keyStr] = curr.valueStr === "true";
                }
            });
            let datass = {
                TEXT_REMINDER_TYPE: datas?.TEXT_REMINDER_TYPE || "",
                TWILIO_ACCOUNT_SID: datas?.TWILIO_ACCOUNT_SID || "",
                TWILIO_ACCOUNT_AUTHTOKEN: datas?.TWILIO_ACCOUNT_AUTHTOKEN || "",
                TWILIO_SMS_FROM_NUMBER: datas?.TWILIO_SMS_FROM_NUMBER || "",
                TEXT_REMINDER: datas?.TEXT_REMINDER || true,
                TWILIO_SMS_SERVICE_SID: datas?.TWILIO_SMS_SERVICE_SID || "",
                TWILIO_SERVICE_SID: datas?.TWILIO_SERVICE_SID || "",
                TWILIO_CONVERSATION_SERVICE_SID: datas?.TWILIO_CONVERSATION_SERVICE_SID || "",
            }
            setVal(datass);
            setPrefer(prefers)
        }
    }

    const areAllEmpty = () => {
        return Object.values(prefer).every(value => value === "");
    };

    // delete a note
    const deleteNote = (id) => {
        let defaultNote = noteData;
        defaultNote = defaultNote.filter((item) => item.id !== id);
        setNoteData(defaultNote);
    };

    const submitNote = () => {
        let submitData = {
            id: Math.random(),
            text: addNoteText,
            date: `${monthNames[todaysDate.getMonth()]} ${todaysDate.getDate()}, ${todaysDate.getFullYear()}`,
            time: `${currentTime()}`,
            company: "Softnio",
        };
        setNoteData([...noteData, submitData]);
        setAddNoteModal(false);
        setAddNoteText("");
    };

    const handleChange = (eve) => {
        const { name, value, checked } = eve?.target;
        if (name === "TEXT_REMINDER") {
            setVal({ ...val, [name]: checked });
        } else {
            setVal({ ...val, [name]: value });
        }
    }

    const handleSubmit = async (eve) => {
        eve?.preventDefault();
        let errors = cloneDeep(error);
        errors.TWILIO_ACCOUNT_AUTHTOKEN = val.TWILIO_ACCOUNT_AUTHTOKEN === "" ? "This Field is Required." : "";
        errors.TWILIO_ACCOUNT_SID = val.TWILIO_ACCOUNT_SID === "" ? "This Field is Required." : "";
        errors.TWILIO_SERVICE_SID = val.TWILIO_SERVICE_SID === "" ? "This Field is Required." : "";
        errors.TWILIO_SMS_SERVICE_SID = val.TWILIO_SMS_SERVICE_SID === "" ? "This Field is Required." : "";
        errors.TWILIO_CONVERSATION_SERVICE_SID = val.TWILIO_CONVERSATION_SERVICE_SID === "" ? "This Field is Required." : "";
        // errors.TWILIO_SMS_FROM_NUMBER = (usaNumRegex)?.test(val?.TWILIO_SMS_FROM_NUMBER?.replace(/[-()\s_]/g, "")) ? "" : "Please Enter valid Number." ;
        errors.TWILIO_SMS_FROM_NUMBER = ((usaNumRegex2)?.test(val?.TWILIO_SMS_FROM_NUMBER) || (usaNumRegex3)?.test(val?.TWILIO_SMS_FROM_NUMBER)) ? "" : "Please Enter valid Number.";
        let formValid = Object?.values(errors)?.every(ele => ele === "");
        if (formValid) {
            if (areAllEmpty()) {

                let data = JSON?.stringify([
                    {
                        tenantId: urlTenantID(),
                        keyStr: "TWILIO_SMS_SERVICE_SID",
                        valueStr: val?.TWILIO_SMS_SERVICE_SID,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    }, {
                        tenantId: urlTenantID(),
                        keyStr: "TWILIO_SERVICE_SID",
                        valueStr: val?.TWILIO_SERVICE_SID,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    }, {
                        tenantId: urlTenantID(),
                        keyStr: "TWILIO_CONVERSATION_SERVICE_SID",
                        valueStr: val?.TWILIO_CONVERSATION_SERVICE_SID,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: urlTenantID(),
                        keyStr: "TWILIO_ACCOUNT_SID",
                        valueStr: val?.TWILIO_ACCOUNT_SID,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: urlTenantID(),
                        keyStr: "TWILIO_ACCOUNT_AUTHTOKEN",
                        valueStr: val?.TWILIO_ACCOUNT_AUTHTOKEN,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: urlTenantID(),
                        keyStr: "TWILIO_SMS_FROM_NUMBER",
                        valueStr: val?.TWILIO_SMS_FROM_NUMBER?.replace(/[-()\s_]/g, ""),
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: urlTenantID(),
                        keyStr: "TEXT_REMINDER",
                        valueStr: val?.TEXT_REMINDER,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: urlTenantID(),
                        keyStr: "TEXT_REMINDER_TYPE",
                        valueStr: val?.TEXT_REMINDER_TYPE,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    }
                ]);
                try {
                    let response = await Api?.insertSmtpSettings(data);
                    Swal?.fire({
                        icon: response?.data?.statusCode === 200 ? "success" : "error",
                        title: response?.data?.statusCode === 200 ? "Sms Setting Updated Succesfully" : "Something Went Wrong"
                    });
                    getSmsSettings();
                } catch (error) {
                    Swal?.fire({
                        icon: "error",
                        title: "Something Went Wrong"
                    });
                }
            } else {
                let data = JSON?.stringify([
                    {
                        tenantId: getTenantId,
                        tenantPrefId: prefer?.TWILIO_ACCOUNT_SID,
                        keyStr: "TWILIO_ACCOUNT_SID",
                        valueStr: val?.TWILIO_ACCOUNT_SID,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: getTenantId,
                        tenantPrefId: prefer?.TWILIO_ACCOUNT_AUTHTOKEN,
                        keyStr: "TWILIO_ACCOUNT_AUTHTOKEN",
                        valueStr: val?.TWILIO_ACCOUNT_AUTHTOKEN,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: getTenantId,
                        tenantPrefId: prefer?.TWILIO_SMS_FROM_NUMBER,
                        keyStr: "TWILIO_SMS_FROM_NUMBER",
                        valueStr: val?.TWILIO_SMS_FROM_NUMBER?.replace(/[-()\s_]/g, ""),
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: getTenantId,
                        tenantPrefId: prefer?.TEXT_REMINDER,
                        keyStr: "TEXT_REMINDER",
                        valueStr: val?.TEXT_REMINDER,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: getTenantId,
                        tenantPrefId: prefer?.TEXT_REMINDER_TYPE,
                        keyStr: "TEXT_REMINDER_TYPE",
                        valueStr: val?.TEXT_REMINDER_TYPE,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: getTenantId,
                        tenantPrefId: prefer?.TWILIO_SMS_SERVICE_SID,
                        keyStr: "TWILIO_SMS_SERVICE_SID",
                        valueStr: val?.TWILIO_SMS_SERVICE_SID,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: getTenantId,
                        tenantPrefId: prefer?.TWILIO_SERVICE_SID,
                        keyStr: "TWILIO_SERVICE_SID",
                        valueStr: val?.TWILIO_SERVICE_SID,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: getTenantId,
                        tenantPrefId: prefer?.TWILIO_CONVERSATION_SERVICE_SID,
                        keyStr: "TWILIO_CONVERSATION_SERVICE_SID",
                        valueStr: val?.TWILIO_CONVERSATION_SERVICE_SID,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    }
                ]);
                try {
                    let response = await Api?.insertSmtpSettings(data);
                    Swal?.fire({
                        icon: response?.data?.statusCode === 200 ? "success" : "error",
                        title: response?.data?.statusCode === 200 ? "Sms Setting Updated Succesfully" : "Something Went Wrong"
                    });
                    getSmsSettings();
                } catch (error) {
                    Swal?.fire({
                        icon: "error",
                        title: "Something Went Wrong"
                    });
                }
            }
        }
        setError(errors);

    }


    return (
        <React.Fragment>
            <Head title="User Details - Regular"></Head>
            {user && (
                <Content>
                    <TenantHeading heading={"Add Tenant Detail"} />
                    <TenantTab match={match} />
                    <Block>
                        <Card className="card-bordered">
                            <div className="card-aside-wrap" id="user-detail-block">
                                <div className="card-content">

                                    <div className="card-inner">
                                        <Block>
                                            <h4 className="mb-5">SMS Settings</h4>
                                            <form onSubmit={eve => handleSubmit(eve)}>
                                                <Row className="mb-3">
                                                    <Col md="6">

                                                        <div className="custom-control custom-switch">
                                                            <input type="checkbox" className="custom-control-input" id="customSwitch2" name="TEXT_REMINDER" onChange={handleChange} checked={val?.TEXT_REMINDER} />
                                                            <label className="custom-control-label text-dark" htmlFor="customSwitch2">
                                                                Enable Text Messaging
                                                            </label>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Col md="6">
                                                        <div className="form-group">
                                                            <Label className="form-label" htmlFor="last-name">
                                                                Text Message Provider Type
                                                            </Label>
                                                            <div className="form-control-wrap">
                                                                <div className="form-control-select">
                                                                    <select
                                                                        className="form-control form-select bg-blue-dim"
                                                                        id="fv-topics"
                                                                        name="TEXT_REMINDER_TYPE"
                                                                        placeholder="Select a option"
                                                                        value={val?.TEXT_REMINDER_TYPE}
                                                                        onChange={handleChange}
                                                                    >
                                                                        <option label="Twilio" value="Twilio"></option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Col md="4">
                                                        <div className="form-group">
                                                            <Label className="form-label" htmlFor="first-name">
                                                                Account SID
                                                            </Label>

                                                            <div className="form-control-wrap">
                                                                <input className="form-control bg-blue-dim" type="text" id="first-name"
                                                                    name="TWILIO_ACCOUNT_SID" value={val?.TWILIO_ACCOUNT_SID} onChange={handleChange} />
                                                                {error?.TWILIO_ACCOUNT_SID && <span className="invalid">{error?.TWILIO_ACCOUNT_SID}</span>}
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col md="4">
                                                        <div className="form-group">
                                                            <Label className="form-label" htmlFor="middle-name">
                                                                Auth Token
                                                            </Label>
                                                            <div className="form-control-wrap">
                                                                <input className="form-control bg-blue-dim" type="text" id="middle-name"
                                                                    name="TWILIO_ACCOUNT_AUTHTOKEN" value={val?.TWILIO_ACCOUNT_AUTHTOKEN} onChange={handleChange} />
                                                                {error?.TWILIO_ACCOUNT_AUTHTOKEN && <span className="invalid">{error?.TWILIO_ACCOUNT_AUTHTOKEN}</span>}
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col md="4">
                                                        <div className="form-group">
                                                            <Label className="form-label" htmlFor="middle-name">
                                                                Twilio SMS Phone Number
                                                            </Label>

                                                            <div className="form-control-wrap">
                                                                <InputMask
                                                                    name="TWILIO_SMS_FROM_NUMBER"
                                                                    mask='+1(999) 999-9999'
                                                                    className="form-control bg-blue-dim"
                                                                    placeholder="+1(999) 999-9999"
                                                                    autoComplete="phone"
                                                                    type="text"
                                                                    value={val?.TWILIO_SMS_FROM_NUMBER}
                                                                    onChange={handleChange}
                                                                >
                                                                </InputMask>
                                                                {error?.TWILIO_SMS_FROM_NUMBER && <span className="invalid">{error?.TWILIO_SMS_FROM_NUMBER}</span>}
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Col md="4">
                                                        <div className="form-group">
                                                            <Label className="form-label" htmlFor="first-name">
                                                                Twilio Verification Service Sid
                                                            </Label>

                                                            <div className="form-control-wrap">
                                                                <input className="form-control bg-blue-dim" type="text" id="first-name"
                                                                    name="TWILIO_SERVICE_SID" value={val?.TWILIO_SERVICE_SID} onChange={handleChange} />
                                                                {error?.TWILIO_SERVICE_SID && <span className="invalid">{error?.TWILIO_SERVICE_SID}</span>}
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col md="4">
                                                        <div className="form-group">
                                                            <Label className="form-label" htmlFor="middle-name">
                                                                Twilio SMS Service Sid
                                                            </Label>
                                                            <div className="form-control-wrap">
                                                                <input className="form-control bg-blue-dim" type="text" id="middle-name"
                                                                    name="TWILIO_SMS_SERVICE_SID" value={val?.TWILIO_SMS_SERVICE_SID} onChange={handleChange} />
                                                                {error?.TWILIO_SMS_SERVICE_SID && <span className="invalid">{error?.TWILIO_SMS_SERVICE_SID}</span>}
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col md="4">
                                                        <div className="form-group">
                                                            <Label className="form-label" htmlFor="middle-name">
                                                                Conversation Service Sid
                                                            </Label>
                                                            <div className="form-control-wrap">
                                                                <input className="form-control bg-blue-dim" type="text" id="middle-name"
                                                                    name="TWILIO_CONVERSATION_SERVICE_SID" value={val?.TWILIO_CONVERSATION_SERVICE_SID} onChange={handleChange} />
                                                                {error?.TWILIO_CONVERSATION_SERVICE_SID && <span className="invalid">{error?.TWILIO_CONVERSATION_SERVICE_SID}</span>}
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <div className="justify-end">
                                                    <Button color="primary" type="submit" onClick={eve => handleSubmit(eve)} className="me-3">Save</Button>
                                                </div>
                                            </form>
                                        </Block>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </Block>
                </Content>
            )}
        </React.Fragment>
    );
};
export default SMSsetting;
